export const sendMail = async ({ subject, body }) => {
  const res = await fetch("https://matsumo333.xsrv.jp/api/send_mail.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      token: "REACT_TO_XSERVER_SECRET",
      subject,
      body,
    }),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.error || "送信に失敗しました");
  }

  return data;
};
